import Image from "next/image";

type BrandingBannerProps = {
	brandingUrl: string;
};

export const BrandingBanner = ({ brandingUrl }: BrandingBannerProps) => (
	<div className="@container w-full">
		<div className="mx-auto flex @[480px]:h-36 h-24 w-full max-w-[768px] justify-center overflow-hidden rounded-t-lg">
			<Image
				className="h-full w-auto max-w-none shrink-0"
				src={brandingUrl}
				width={768}
				height={144}
				// Decorative
				alt=""
				role="presentation"
				priority
				sizes="(max-width: 768px) 100vw, 768px"
			/>
		</div>
	</div>
);
